/* =============================================================
   DARK / LIGHT THEME TOGGLE — JavaScript
   Telescopes Canada (Warehouse Theme)

   HOW TO INSTALL:
   1. Upload this file to Assets as "dark-mode-toggle.js"
   2. In layout/theme.liquid, add before </body>:
      <script src="{{ 'dark-mode-toggle.js' | asset_url }}" defer></script>
   ============================================================= */

(function () {
  'use strict';

  var STORAGE_KEY = 'tc-theme-preference';
  var DARK_CLASS = 'dark-mode';
  var LOADING_CLASS = 'tc-theme-loading';

  /**
   * Get the stored preference, or null if none set.
   */
  function getPreference() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  /**
   * Save preference to localStorage.
   */
  function setPreference(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // localStorage unavailable — graceful degradation
    }
  }

  /**
   * Apply the theme class to <html>.
   */
  function applyTheme(isDark) {
    if (isDark) {
      document.documentElement.classList.add(DARK_CLASS);
    } else {
      document.documentElement.classList.remove(DARK_CLASS);
    }
  }
 
  /**
   * Determine if dark mode should be active on initial load.
   */
  function shouldBeDark() {
    var pref = getPreference();
    if (pref === 'dark') return true;
    if (pref === 'light') return false;
    // No stored preference — respect OS preference
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      return true;
    }
    return false;
  }

  /**
   * Toggle dark mode.
   */
  function toggle() {
    var isDark = document.documentElement.classList.contains(DARK_CLASS);
    var newState = !isDark;
    applyTheme(newState);
    setPreference(newState ? 'dark' : 'light');
  }

  /**
   * Create the toggle button and inject it into the header.
   */
  function createToggleButton() {
    var btn = document.createElement('button');
    btn.className = 'tc-theme-toggle';
    btn.setAttribute('aria-label', 'Toggle dark mode');
    btn.setAttribute('title', '');
    btn.type = 'button';

    // Sun icon (shown in dark mode)
    var sunSVG = '<svg class="tc-icon-sun" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="5"></circle>' +
      '<line x1="12" y1="1" x2="12" y2="3"></line>' +
      '<line x1="12" y1="21" x2="12" y2="23"></line>' +
      '<line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>' +
      '<line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>' +
      '<line x1="1" y1="12" x2="3" y2="12"></line>' +
      '<line x1="21" y1="12" x2="23" y2="12"></line>' +
      '<line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>' +
      '<line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>' +
      '</svg>';

    // Moon icon (shown in light mode)
    var moonSVG = '<svg class="tc-icon-moon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>' +
      '</svg>';

    btn.innerHTML = sunSVG + moonSVG;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggle();
    });

    return btn;
  }

  /**
   * Inject the toggle button into the Warehouse theme header.
   * Warehouse v6 uses .header__action-list with .header__action-item divs.
   * We insert before the cart item, wrapped in the same div structure.
   */
  function injectButton() {
    var btn = createToggleButton();

    // Strategy 1: Warehouse v6 — find .header__action-item--cart and insert before it
    var cartItem = document.querySelector('.header__action-item--cart');
    if (cartItem && cartItem.parentNode) {
      var wrapper = document.createElement('div');
      wrapper.className = 'header__action-item';
      wrapper.appendChild(btn);
      cartItem.parentNode.insertBefore(wrapper, cartItem);
      return;
    }

    // Strategy 2: Find header action list and append wrapped
    var headerActions = document.querySelector('.header__action-list, .header__icons, .header__actions');
    if (headerActions) {
      var wrapper = document.createElement('div');
      wrapper.className = 'header__action-item';
      wrapper.appendChild(btn);
      headerActions.appendChild(wrapper);
      return;
    }

    // Strategy 3: Fallback — fixed position button (bottom-right corner)
    btn.style.position = 'fixed';
    btn.style.bottom = '20px';
    btn.style.right = '20px';
    btn.style.zIndex = '9999';
    btn.style.background = '#1A1E21';
    btn.style.boxShadow = '0 2px 10px rgba(0,0,0,0.3)';
    btn.style.borderRadius = '50%';
    btn.style.width = '44px';
    btn.style.height = '44px';
    document.body.appendChild(btn);
  }

  // --- INITIALIZATION ---

  // Apply theme immediately (no flash)
  applyTheme(shouldBeDark());

  // Remove loading class after a brief delay to re-enable transitions
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      document.documentElement.classList.remove(LOADING_CLASS);
    });
  });

  // Listen for OS preference changes
  if (window.matchMedia) {
    try {
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
        // Only respond to OS changes if user hasn't set a manual preference
        if (!getPreference()) {
          applyTheme(e.matches);
        }
      });
    } catch (e) {
      // Older browsers — silent fail
    }
  }

  // Inject button when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectButton);
  } else {
    injectButton();
  }

})();
